import {getIntersectCordsBetweenLines, getPointOnTheLine} from "../../../../../helpers/sqftHelper";

export function expandLineAndClosestPoints(line, diff) {

  const shape = line.getParent();
  const prevLine = shape.getPrevLine(line);
  const nextLine = shape.getNextLine(line);
  const prevPrevLine = shape.getPrevLine(prevLine);
  const nextNextLine = shape.getNextLine(nextLine);

  // 1)
  const offset = diff / 2;

  // 2) Move the main line's endpoints along itself
  const oldFrom = { x: line.from.x, y: line.from.y };
  const oldTo   = { x: line.to.x,   y: line.to.y };

  const newFrom = getPointOnTheLine(line.from, line.to, offset);
  const newTo   = getPointOnTheLine(line.to,   line.from, offset);

  // Update the main line
  line.from.x = newFrom.x;
  line.from.y = newFrom.y;
  line.to.x   = newTo.x;
  line.to.y   = newTo.y;

  // 3) Calculate shift vectors
  const deltaFrom = {
    x: newFrom.x - oldFrom.x,
    y: newFrom.y - oldFrom.y
  };
  const deltaTo = {
    x: newTo.x - oldTo.x,
    y: newTo.y - oldTo.y
  };

  // 3) For nextLine: shift it by deltaTo, then intersect with nextNextLine
  if (nextLine && nextNextLine) {
    // Build a "temp" offset version of nextLine
    const tempNextLine = {
      from: { x: newTo.x, y: newTo.y },
      to: { x: nextLine.to.x + deltaTo.x, y: nextLine.to.y + deltaTo.y }
    };

    // Intersect "tempNextLine" with nextNextLine
    const newCorner = getIntersectCordsBetweenLines(
      tempNextLine.from,
      tempNextLine.to,
      nextNextLine.from,
      nextNextLine.to,
      true,
      true
    );

    // If intersection is valid, update nextLine.to
    if (newCorner) {
      nextLine.to.x = newCorner.x;
      nextLine.to.y = newCorner.y;
    }
  }

  // 4) For prevLine: shift it by deltaFrom, then intersect with prevPrevLine
  if (prevLine && prevPrevLine) {
    const tempPrevLine = {
      from: { x: prevLine.from.x + deltaFrom.x, y: prevLine.from.y + deltaFrom.y },
      to: { x: newFrom.x, y: newFrom.y }
    };

    const newCorner = getIntersectCordsBetweenLines(
      tempPrevLine.from,
      tempPrevLine.to,
      prevPrevLine.from,
      prevPrevLine.to,
      true,
      true
    );

    if (newCorner) {
      prevLine.from.x = newCorner.x;
      prevLine.from.y = newCorner.y;
    }
  }

  // Attachments adjustment
  const linesToAdjust = [line, prevLine, nextLine];

  linesToAdjust.forEach(adjLine => {
    if (!adjLine) return;

    const dx = (adjLine === prevLine) ? deltaFrom.x : deltaTo.x;
    const dy = (adjLine === prevLine) ? deltaFrom.y : deltaTo.y;

    if (adjLine.isWithBumpout()) {
      adjLine.bumpoutOverlay.moveBumpout(-dx, -dy);
    }

    if (adjLine.isWithMitered()) {
      adjLine.miteredOverlay.moveMitered(-dx, -dy);
    }

    if (adjLine.isWithUnderlayment()) {
      adjLine.underlaymentOverlay.moveMitered(-dx, -dy);
    }
  });
}
